<template>
  <BaseModal
    class="bank-details-modal"
    :is-open="isOpen"
    size="md"
    data-testid="bank-details-modal"
    @close="emitCloseEvent"
    v-on="$listeners"
  >
    <template #header>
      <NavBar
        data-testid="bank-details-navbar"
        class="bank-details-modal__navbar"
      >
        <template #center>Conta Digital</template>
        <template #right>
          <CloseButton @click="emitCloseEvent" />
        </template>
      </NavBar>
    </template>

    <template #content>
      <section
        v-if="!hasMoneyInAccount"
        class="bank-details-modal__warning"
        role="contentinfo"
        data-testid="bank-details-no-money-warning"
        aria-label="Faça um depósito na sua conta"
      >
        <Heading class="bank-details-modal__section-title" :level="3">
          Faça um depósito na sua conta
        </Heading>
        <BaseText :color="NebraskaColors.textSecondary" size="sm">
          Para ter saldo, realize a transferência por meio de uma conta bancária
          em que você é titular, ou deposite por boleto.
        </BaseText>
      </section>
      <div class="bank-details-modal__content">
        <section
          role="contentinfo"
          aria-label="Dados necessários para depósito"
          data-testid="bank-details-deposit-info"
        >
          <Heading class="bank-details-modal__section-title" :level="3">
            Dados para depósito
          </Heading>
          <BankAccount
            :bank-name="bankAccount.bankName"
            :bank-code="bankAccount.bankCode"
            :agency="bankAccount.agency"
            :account="bankAccount.account"
            :document="bankAccount.document"
            :name="bankAccount.name"
          />

          <BaseText
            :color="NebraskaColors.textSecondary"
            class="bank-details-modal__disclaimer-info"
            size="sm"
          >
            Seu dinheiro é enviado via SBP (Sistema de Pagamento Brasileiro),
            que funciona das 6h30 até as 17h30. Valores transferidos dentro
            desse horário ficam disponíveis em poucos minutos na plataforma.
          </BaseText>
        </section>

        <section
          v-if="!hasMoneyInAccount"
          role="contentinfo"
          aria-label="Atualize seu saldo"
          class="bank-details-modal__section"
          data-testid="bank-details-update-balance"
        >
          <Heading class="bank-details-modal__section-title" :level="3">
            Atualize seu saldo
          </Heading>
          <BaseText :color="NebraskaColors.textSecondary" size="sm">
            Após fazer o depósito para sua conta, é possível atualizar o valor
            do seu saldo e assim realizar seu investimento.
          </BaseText>
          <img
            class="bank-details-modal__tutorial-image"
            src="/assets/investment/refresh-money-in-account.gif"
          />
        </section>
      </div>
    </template>

    <template v-if="!hasMoneyInAccount" #footer>
      <ModalFooter
        data-testid="bank-details-modal-footer"
        left-button-label="Entendi"
        hide-right-button
        @left-button-clicked="emitCloseEvent"
      />
    </template>
  </BaseModal>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { ModalFooter } from '@/modules/common/components/__deprecated__/Modal';
import { CloseButton } from '@/modules/common/components/buttons';
import {
  NavBar,
  BankAccount,
  Heading,
  BaseText,
  BaseModal
} from '@warrenbrasil/nebraska-web';
import { IBankAccount } from '@/modules/transaction/views/InvestmentTransaction/types';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

@Component({
  components: {
    BankAccount,
    ModalFooter,
    CloseButton,
    NavBar,
    Heading,
    BaseText,
    BaseModal
  }
})
export default class BankDetailsModal extends Vue {
  @Prop({ type: Boolean, required: true })
  private isOpen!: boolean;

  @Prop({ type: String, required: true })
  private investmentAccountId!: string;

  @Prop({ type: Object, required: true })
  private bankAccount!: IBankAccount;

  @Prop({ type: Boolean, default: true })
  private hasMoneyInAccount!: boolean;

  private NebraskaColors = NebraskaColors;

  private emitCloseEvent() {
    this.$emit('close');
  }
}
</script>

<style lang="less" scoped>
.bank-details-modal {
  &__warning {
    background: @background-primary;
    padding: @size-spacing-x600 @size-spacing-x400;
  }

  &__content {
    padding: @size-spacing-x600 @size-spacing-x400;
  }

  &__section {
    margin-top: @size-spacing-x800;
  }

  &__section {
    margin-top: @size-spacing-x800;
  }

  &__section-title,
  &__disclaimer-info {
    margin-bottom: @size-spacing-x300;
  }
  &__invoice-info {
    margin-bottom: @size-spacing-x500;
  }

  &__tutorial-image {
    margin-top: @size-spacing-x350;
    display: block;
    max-width: 100%;
  }

  @media @tabletUp {
    &__warning,
    &__content {
      padding: @size-spacing-x800 @size-spacing-x1000;
    }
  }
}
</style>
